module.exports = __webpack_public_path__ + "media/components/shared/static/arrow_prev-7ce43c7638818ea1c0a54fc111b92c0e.svg";